/**
 * Path of the client inbox item a reporter can watch.
 *
 * The widget does not know the portal origin (its `apiBase` is the API), so
 * the event carries this path and the host prefixes whatever origin serves
 * the portal. `ticket` is the request id, which is what
 * `SupportInboxPage` reads.
 */
export function itemStatusPath(id: string): string {
  return `/embed/requests?ticket=${encodeURIComponent(id)}`;
}

export interface FiledCloseDetail {
  reference: string;
  id?: string;
  href?: string;
}

/** `fm:close` detail after a successful send. No id means no link. */
export function filedCloseDetail(filed: { reference: string; id?: string } | undefined): FiledCloseDetail | undefined {
  if (!filed) return undefined;
  if (!filed.id) return { reference: filed.reference };
  return { reference: filed.reference, id: filed.id, href: itemStatusPath(filed.id) };
}
